// const API_KEY = "AIzaSyCa_O8wNgb2294kh39jFVfmNNlNXDqQZXE";
// const AUTH_DOMAIN = "advanced-movie-rating.firebaseapp.com";
// const PROJECT_ID = "advanced-movie-rating";
// const STORAGE_BUCKET = "advanced-movie-rating.appspot.com";
// const MESSAGIN_SENDER_ID = "808526797452";
// const APP_ID = "1:808526797452:web:5e9a2bad9bd958e1bcb9a9";
// const MEASUREMENT_ID = "G-YDDDQBCPJ7";
// const APP_REQUEST_KEY = "0aecf6db407ccb300d17f65b602b98c5";

const API_KEY = "AIzaSyBnPI_s1E28zVp2MMdZq9giL3J9hBzaS3c";
const TEST_DRIVE_API_REQUST = "1052072-Movie-DA275235";
const AUTH_DOMAIN = "movie-world-c0ded.firebaseapp.com";
const PROJECT_ID = "movie-world-c0ded";
const STORAGE_BUCKET = "movie-world-c0ded.firebasestorage.app";
const MESSAGIN_SENDER_ID = "326621195262";
const APP_ID = "1:326621195262:web:6a63e2b5f7d3e3c4a7eeaf";
const MEASUREMENT_ID = "G-R1MTMLGM50";
const APP_REQUEST_KEY = "0aecf6db407ccb300d17f65b602b98c5";

export {
  API_KEY,
  TEST_DRIVE_API_REQUST,
  AUTH_DOMAIN,
  PROJECT_ID,
  STORAGE_BUCKET,
  MESSAGIN_SENDER_ID,
  APP_ID,
  MEASUREMENT_ID,
  APP_REQUEST_KEY
};
